import { ServerInfoBundle } from '@go-client/context/ServerInfoContext';
import { AuthorizationError, getErrorMessage } from '../../shared/errors';
import { Access, ApiToken } from '../../shared/types/auth';
import { getStorage, setStorage, unsetStorage } from './storage';

export function storeUserToken(token: string) {
  setStorage('apiTokenKey', token);
}

export function getUserToken(): string | undefined {
  return getStorage().apiTokenKey;
}

export function clearUserToken() {
  unsetStorage('apiTokenKey');
}

export function parseUserToken(token: string): ApiToken {
  try {
    let parts = token.split('.');
    let payload = parts[1];
    let tokenContents = atob(payload);
    return JSON.parse(tokenContents) as ApiToken;
  } catch (e) {
    throw new AuthorizationError(`Invalid user token: ${getErrorMessage(e)}`);
  }
}

export function parseLoggedUserToken(): ApiToken {
  let tokenString = getUserToken();
  if (!tokenString) {
    throw new AuthorizationError(`Could not find user token`);
  }
  return parseUserToken(tokenString);
}

export function getInstancePropIdIfUserCan(serverInfo: ServerInfoBundle, role: Access) {
  const { instanceRole, property } = serverInfo;

  if (instanceRole !== 'property' || !property) return undefined;

  switch (role.level) {
    case 'brand':
      return property._id;
    case 'property':
      return role.access.includes(property._id) ? property._id : undefined;
  }
}
